import TrackWrapper from '~/components/common/TrackWrapper';
import { appAssetsCdnUrl } from '~/constants/environment';
import formatEvent from '~/utilities/formatEvent';
import optimizeImage from '~/utilities/optimizeImage';

export default function Header() {
  const iconUrl = optimizeImage(
    `${appAssetsCdnUrl}/images/shaqvana/shaqvana-logo.png`,
    {
      format: 'auto',
      quality: 90
    }
  );

  return (
    <TrackWrapper
      className="px-2xl py-xl sm:px-3xl md:px-[84px]"
      event={formatEvent('Header', {
        action: 'viewed'
      })}
    >
      <a href="/" data-analytics-id="Header" data-testid="home-link">
        <img src={iconUrl} alt="Shaqvana Image" className="h-[34px]" />
      </a>
    </TrackWrapper>
  );
}
